import React from 'react';
import { Button, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import PricingItem from './PricingItem';
import { useActivityItemPricingStepStyles } from './ActivityItemPricingStyles';
import { v4 as uuidv4 } from 'uuid';
import { LOT_OPTIONS } from './ActivityItemPricingConsts';

const AddPricing = ({ pricingItems, setPricingItems, onUnsavedChanges, lots, clients, vendors, vehicleTypes, usePricingCalculator = true, requireVendor = true, allowDefaultClient = true, pricingType, materials }) => {
    const classes = useActivityItemPricingStepStyles();

    const onAdd = () => {
        setPricingItems([
            {
                tempId: `${Date.now()}-${uuidv4()}`,
                isNew: true,
                lotOption: LOT_OPTIONS.ALL_LOTS,
                ...(usePricingCalculator ? {} : { price: null }),
            },
            ...pricingItems
        ]);
    };

    return (
        <>
            <Button
                color="primary"
                variant="outlined"
                onClick={onAdd}
                startIcon={<AddIcon />}
                disabled={pricingItems?.some(p => p.isNew)}
            >
                Add Pricing
            </Button>
            <Grid container direction="column" spacing={1} className={classes.pricingList}>
                {pricingItems?.map((item, index) => (
                    <Grid item key={item.id || item.tempId || index}>
                        <PricingItem
                            item={item}
                            itemIndex={index}
                            pricingItems={pricingItems}
                            setPricingItems={setPricingItems}
                            onUnsavedChanges={onUnsavedChanges ? (hasUnsaved) => onUnsavedChanges(item.id || item.tempId || index, hasUnsaved) : undefined}
                            lots={lots}
                            clients={clients}
                            vendors={vendors}
                            vehicleTypes={vehicleTypes}
                            usePricingCalculator={usePricingCalculator}
                            requireVendor={requireVendor}
                            allowDefaultClient={allowDefaultClient}
                            pricingType={pricingType}
                            materials={materials}
                        />
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

export default AddPricing;
